__webpack_require__.p = "/xsportapp/xsport_mobile/";